import { render, staticRenderFns } from "./ProjectFeatureItem.vue?vue&type=template&id=4c4b8350&scoped=true&"
import script from "./ProjectFeatureItem.vue?vue&type=script&lang=js&"
export * from "./ProjectFeatureItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFeatureItem.vue?vue&type=style&index=0&id=4c4b8350&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b8350",
  null
  
)

export default component.exports